import script from "./Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./Edit.vue?vue&type=style&index=1&id=2513753e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2513753e"]])

export default __exports__